import React from 'react';
import { motion } from 'framer-motion';

const StoreButtons = ({ variant = 'secondary', size = 'normal' }) => {
  const isSmall = size === 'small';
  const baseHeight = isSmall ? '40px' : '56px';
  const basePaddingX = isSmall ? '16px' : '24px';
  const baseFontSize = isSmall ? '0.85rem' : '1rem';
  const iconSize = isSmall ? '20px' : '28px';

  const appStoreButton = (
    <motion.a
      href="https://apps.apple.com/app/derkenar"
      target="_blank"
      rel="noopener noreferrer"
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '10px',
        backgroundColor: '#000000',
        color: '#ffffff',
        padding: `0 ${basePaddingX}`,
        height: baseHeight,
        borderRadius: '8px',
        textDecoration: 'none',
        fontFamily: "'Filson Soft', sans-serif",
        fontWeight: '700',
        fontSize: baseFontSize,
        transition: 'all 0.3s ease',
        border: 'none',
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = '#1a1a1a';
        e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.2)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = '#000000';
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
      }}
    >
      <img
        src="/logo/apple-logo.svg"
        alt="Apple"
        style={{
          width: iconSize,
          height: iconSize,
          filter: 'brightness(0) invert(1)'
        }}
      />
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
        <span style={{ fontSize: isSmall ? '0.65rem' : '0.75rem', opacity: 0.8 }}>
          Download on the
        </span>
        <span style={{ fontSize: isSmall ? '0.85rem' : '1rem', fontWeight: 'bold' }}>
          App Store
        </span>
      </div>
    </motion.a>
  );

  const googlePlayButton = (
    <motion.a
      href="https://play.google.com/store/apps/details?id=com.derkenar"
      target="_blank"
      rel="noopener noreferrer"
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '10px',
        backgroundColor: '#000000',
        color: '#ffffff',
        padding: `0 ${basePaddingX}`,
        height: baseHeight,
        borderRadius: '8px',
        textDecoration: 'none',
        fontFamily: "'Filson Soft', sans-serif",
        fontWeight: '700',
        fontSize: baseFontSize,
        transition: 'all 0.3s ease',
        border: 'none',
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = '#1a1a1a';
        e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.2)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = '#000000';
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
      }}
    >
      <img
        src="/logo/google-logo.svg"
        alt="Google Play"
        style={{
          width: iconSize,
          height: iconSize
        }}
      />
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
        <span style={{ fontSize: isSmall ? '0.65rem' : '0.75rem', opacity: 0.8 }}>
          Get it on
        </span>
        <span style={{ fontSize: isSmall ? '0.85rem' : '1rem', fontWeight: 'bold' }}>
          Google Play
        </span>
      </div>
    </motion.a>
  );

  return (
    <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
      {appStoreButton}
      {googlePlayButton}
    </div>
  );
};

export default StoreButtons;
